/** @module components/Breadcrumb */

import { Icon } from "react-aiot";
import React from "react";
const ICON_OBJ_SEP = /*#__PURE__*/React.createElement(Icon, {
  type: "right"
});

/**
 * Simple breadcrumbs with arrows and a home icon.
 *
 * @property {string[]} path The pathes
 * @type React.Element
 */
export default (_ref => {
  let {
    path,
    closeable = false,
    onClose
  } = _ref;
  let i = 0; // Use counter as key
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    type: "folder"
  }), "\xA0\xA0", path.map(item => {
    return /*#__PURE__*/React.createElement("span", {
      key: i++
    }, item, "\xA0", i < path.length && ICON_OBJ_SEP, "\xA0");
  }), !!closeable && /*#__PURE__*/React.createElement(Icon, {
    type: "close",
    onClick: onClose
  }));
});